<template>
    <div>
        <van-nav-bar title="合同详情" left-arrow @click-left="onClickLeft" />
        <van-tabs v-model="selected" type="line" sticky v-on:click="switchTab" >
            <van-tab title="合同详情">
                <div>
                    <div class="bottom-div">
                        <van-button type="danger" size="large" width="100%" @click="openForm">打开合同详情</van-button>
                    </div>
                </div>
            </van-tab>
            <van-tab title="收款计划">
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh(1)">
                    <van-list v-model="loading" :finished="finished" finished-text="没有更多了">
                        <div v-for="receipt in receiptList" class="card" :key="receipt.uuid" @click="receiptDetail(receipt)" >
                            <table class="layout">
                                <tr>
                                    <td colspan="3" class="title"><span class="iconfont icon-date"></span>
                                        {{receipt.planReceiptDate}}</td>
                                    <td colspan="2" class="title"><span class="iconfont icon-money-rmb"></span>
                                        {{receipt.amount}}</td>
                                    <td colspan="2" style="text-align: right;">
                                        <span style="color: #FF1717;" v-if="receipt.status === '已逾期'">{{receipt.status}}</span>
                                        <span style="color: #1297DB;" v-if="receipt.status === '待收款'">{{receipt.status}}</span>
                                        <span style="color: #CC6633;" v-if="receipt.status === '坏账'">{{receipt.status}}</span>
                                        <span v-if="receipt.status === '已收款'"><van-tag color="#F63C53" plain>已收迄</van-tag></span>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="progressTitle">已收</td>
                                    <td colspan="4"><van-progress pivot-text="" color="#66CC66" :percentage="receipt.amountProgress" /></td>
                                    <td class="progressAmount" colspan="2">{{receipt.receivedAmount}}</td>
                                </tr>
                                <tr>
                                    <td class="progressTitle">已开</td>
                                    <td colspan="4"><van-progress pivot-text="" color="#66CC66" :percentage="receipt.invoiceProgress" /></td>
                                    <td class="progressAmount" colspan="2">{{receipt.invoicedAmount}}</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                        <van-button style="opacity: 0.7;" v-if="receipt.status ==='坏账' || receipt.invoicedAmount !== '0.00' || !receipt.createInvoice"
                                                    disabled round plain size="small">开票</van-button>
                                        <van-button v-if="receipt.status !=='坏账' && receipt.invoicedAmount === '0.00' && receipt.createInvoice"
                                                    round plain size="small" type="info" @click="invoiceAmount(receipt,$event)">开票</van-button>
                                    </td>
                                    <td>
                                        <van-button style="opacity: 0.7;" v-if="receipt.status ==='坏账' || receipt.receivedAmount !== '0.00' || !receipt.createReceipt"
                                                    disabled round plain size="small">收款</van-button>
                                        <van-button v-if="receipt.status !=='坏账' && receipt.receivedAmount === '0.00' && receipt.createReceipt"
                                                    round plain size="small" type="info" @click="receiptAmount(receipt,$event)">收款</van-button>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </van-list>
                </van-pull-refresh>
            </van-tab>
            <van-tab title="到账记录">
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh(2)">
                    <van-list v-model="loading" :finished="finished" finished-text="没有更多了">
                        <div v-for="cashFlow in cashFlowList" class="card" :key="cashFlow.uuid" >
                            <table class="layout">
                                <tr>
                                    <td class="title"><span class="iconfont icon-date"></span>
                                        {{cashFlow.receivePayTime}}</td>
                                    <td class="title"><span class="iconfont icon-money-rmb"></span>
                                        {{cashFlow.amount}}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td colspan="1">
                                        <span style="color: #808080">{{cashFlow.paymentTypename}}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <span style="color: #808080;" v-if="cashFlow.currentState === '已完成'">{{cashFlow.currentState}}</span>
                                        <span style="color: #000000;" v-if="cashFlow.currentState === '已保存'">{{cashFlow.currentState}}</span>
                                        <span style="color: #ff0000;" v-if="cashFlow.currentState === '已退回'">{{cashFlow.currentState}}</span>
                                        <span style="color: #1297DB;" v-if="cashFlow.currentState !== '已完成'
                                    && cashFlow.currentState !== '已退回' && cashFlow.currentState !== '已保存' ">{{cashFlow.currentState}}</span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </van-list>
                </van-pull-refresh>
            </van-tab>
            <van-tab title="开票记录">
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh(3)">
                    <van-list v-model="loading" :finished="finished" finished-text="没有更多了">
                        <div v-for="invoiceRecord in invoiceRecordList" class="card" :key="invoiceRecord.uuid" >
                            <table class="layout">
                                <tr>
                                    <td class="title"><span class="iconfont icon-date"></span>
                                        {{invoiceRecord.invoiceDate}}</td>
                                    <td class="title"><span class="iconfont icon-money-rmb"></span>
                                        {{invoiceRecord.invoiceAmount}}</td>
                                </tr>
                                <tr>
                                    <td style="color: #808080">{{invoiceRecord.invoiceTypename}}</td>
                                    <td style="color: #808080">税率：{{invoiceRecord.invoiceTax}}%</td>
                                    <td style="color: #808080">税额：{{invoiceRecord.invoiceTaxAmount}}</td>
                                </tr>
                                <tr>
                                    <td colspan="3" style="color: #808080">发票号码：{{invoiceRecord.invoiceSerial}}</td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <span style="color: #808080;" v-if="invoiceRecord.currentState === '已完成'">{{invoiceRecord.currentState}}</span>
                                        <span style="color: #000000;" v-if="invoiceRecord.currentState === '已保存'">{{invoiceRecord.currentState}}</span>
                                        <span style="color: #ff0000;" v-if="invoiceRecord.currentState === '已退回'">{{invoiceRecord.currentState}}</span>
                                        <span style="color: #1297DB;" v-if="invoiceRecord.currentState !== '已完成'
                                    && invoiceRecord.currentState !== '已退回' && invoiceRecord.currentState !== '已保存' ">{{invoiceRecord.currentState}}</span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </van-list>
                </van-pull-refresh>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
    /**
     * import  引用
     */
    import {Tab,Tag,Tabs, Panel, Field, List, Search, PullRefresh, Button, Progress, NavBar} from 'vant';
    import userInfo from '../store/userInfo';
    import orderService from "../service/orderService";
    import moment from "moment";
    import {formatDictionary} from "../utils/dictionary";
    import {formatMoney} from "../utils/money";
    import {getKey} from "../utils/url";

    export default {
        /**
         * 页面数据存放位置
         */
        data: function () {
            return {
                data:{},
                receiptList: [],
                cashFlowList: [],
                invoiceRecordList: [],
                loading: false,
                finished: false,
                pageIndex: 0,
                selected: 0,
                orderId: '',
                workflowTemplate: '67a41bcca93311e9a1d17cd30aeb1fda',
                refreshing: false,
                isSummaryEntry:false  //是否从汇总页面进来
            }
        },
        /**
         * 用户信息
         */
        store: userInfo,
        /**
         * 组件注册
         */
        components: {
            [Tab.name]: Tab,
            [Tag.name]: Tag,
            [Progress.name]: Progress,
            [Button.name]: Button,
            [Tabs.name]: Tabs,
            [Panel.name]: Panel,
            [Field.name]: Field,
            [List.name]: List,
            [Search.name]: Search,
            [PullRefresh.name]: PullRefresh,
            [NavBar.name]:NavBar
        },
        computed: {
        },
        /**
         * 页面加载时调用
         */
        mounted: async function () {
            //获取url中的参数
            this.orderId = getKey("id");
            let isSummaryEntry = getKey("isSummaryEntry");
            if(isSummaryEntry === "true"){
                this.isSummaryEntry = true;
            }
            this.selected = parseInt(getKey("selected"));
            if (this.selected) {
                this.switchTab(this.selected);
            }
            //获取合同信息
            let resp =  await orderService.getOrderById(this.orderId);
            if (resp.data.Status === "1"){
                this.data = resp.data.Data;
            }
        },
        methods: {
            /**
             * 刷新
             */
            onRefresh(index){
                this.finished = false;
                this.pageIndex = 0;
                switch (index) {
                    case 1:
                        this.receiptList = [];
                        this.getReceiptList();
                        break;
                    case 2:
                        this.cashFlowList = [];
                        this.getCashFlow();
                        break;
                    case 3:
                        this.invoiceRecordList = [];
                        this.getInvoiceRecord();
                        break;
                }
            },
            /**
             * 打开合同详情
             */
            openForm() {
                window.open('/wf/form/vsheet/form?workflowTemplateId='+this.workflowTemplate+'&id=' + this.orderId);
            },
            /**
             * 收款计划列表
             */
            async getReceiptList(){
                this.pageIndex++;
                let resp = await orderService.getReceiptList(this.pageIndex,this.orderId);
                resp.data.Data.data.forEach(receipt => {
                    //日期格式化
                    receipt.planReceiptDate = moment(receipt.planReceiptDate).format('YYYY-MM-DD');
                    receipt.amountProgress = receipt.receivedAmount ? receipt.receivedAmount*100 /receipt.planReceiptAmount : 0;
                    receipt.invoiceProgress = receipt.invoicedAmount ? receipt.invoicedAmount*100 / receipt.planReceiptAmount  : 0;
                    //金额格式化
                    receipt.amount = formatMoney(receipt.planReceiptAmount);
                    receipt.receivedAmount = formatMoney(receipt.receivedAmount||0);
                    receipt.invoicedAmount = formatMoney(receipt.invoicedAmount||0);
                });
                // 字典格式化
                formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                this.loading = false;
                this.refreshing = false;
                this.receiptList = [...this.receiptList, ...resp.data.Data.data];
                this.finished = resp.data.Data.total <= this.receiptList.length;
            },

            /**
             *  开票记录
             */
            async getInvoiceRecord(){
                this.pageIndex++;
                let resp = await orderService.getInvoiceRecordList(this.pageIndex,this.orderId);
                resp.data.Data.data.forEach(invoiceRecord => {
                    //日期格式化
                    invoiceRecord.invoiceDate = moment(invoiceRecord.invoiceDate).format('YYYY-MM-DD');
                    //金额格式化
                    invoiceRecord.invoiceAmount = formatMoney(invoiceRecord.invoiceAmount);

                });
                // 字典格式化
                formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                this.loading = false;
                this.refreshing = false;
                this.invoiceRecordList = [...this.invoiceRecordList, ...resp.data.Data.data];
                this.finished = resp.data.Data.total <= this.invoiceRecordList.length;
            },
            /**
             *  到账记录
             */
            async getCashFlow(){
                this.pageIndex++;
                let resp = await orderService.getCashFlowList(this.pageIndex,this.orderId);
                resp.data.Data.data.forEach(cashFlow => {
                    //日期格式化
                    cashFlow.receivePayTime = moment(cashFlow.receivePayTime).format('YYYY-MM-DD');
                    //金额格式化
                    cashFlow.amount = formatMoney(cashFlow.amount);

                });
                // 字典格式化
                formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                this.loading = false;
                this.refreshing = false;
                this.cashFlowList = [...this.cashFlowList, ...resp.data.Data.data];
                this.finished = resp.data.Data.total <= this.cashFlowList.length;
            },

            /**
             *  标签切换
             */
            switchTab(index) {
                window.scrollTo(0, 0);
                this.onRefresh(index)
            },
            /**
             *  收款申请
             */
            receiptAmount(receipt,e){
                e.stopPropagation();
                let url = "";
                if (receipt.receiptApplicationId){
                    url = "/wf/form/vsheet/form?workflowTemplateId=caec20dd69324107925ee788d29b2099&id="+receipt.receiptApplicationId;
                }else {
                    let params = "customerId="+this.data.customerId+"&orderId="+this.orderId+"&planReceiptDate="+receipt.planReceiptDate+"&planReceiptAmount="+receipt.planReceiptAmount+
                        "&planRemark="+receipt.remark+"&planId="+receipt.uuid;
                    url = "/wf/form/vsheet/form?workflowTemplateId=caec20dd69324107925ee788d29b2099&id=0&"+params;
                }
                window.open(url);

            },
            /**
             *  开票申请
             */
            invoiceAmount(receipt,e){
                e.stopPropagation();
                let url = "";
                if (receipt.invoiceApplicationId){
                    url = "/wf/form/vsheet/form?workflowTemplateId=8dac6e8e97b011e9884300155d465b14&id="+receipt.invoiceApplicationId;
                }else {
                    let params ="customerId="+this.data.customerId+"&orderId="+this.orderId+"&invoiceAmount="+receipt.planReceiptAmount+"&planId="+receipt.uuid;
                    url = "/wf/form/vsheet/form?workflowTemplateId=8dac6e8e97b011e9884300155d465b14&id=0&"+params;
                }
                window.open(url);
            },
            /**
             * 打开收款计划详情
             * @param receipt
             */
            receiptDetail(receipt){
                this.$router.push("/receiptPlanDetail?orderId="+this.orderId+"&isSummaryEntry="+this.isSummaryEntry+"&objData="+JSON.stringify(receipt));
            },
            onClickLeft(){
                if (this.isSummaryEntry){
                    this.$router.push("/order/summary?isHideTitle=1");
                }else {
                    window.open("colseWebView");
                }
            }
        }
    };
</script>

<style scoped>
    .layout tr{
        height: 2rem;
    }
    .layout td{
        width: 14%;
    }
    .progressTitle{
        text-align: right;
        color: #999999;
    }
    .progressAmount{
        color: #999999;
        padding-left: 0.5rem;
    }
    .van-button--default {
        border: 1px solid #C9C9C9;
    }
    .bottom-div{
        position: absolute;
        width: 100%;
    }
    .title {
        font-size: 0.9rem;
    }
</style>